var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { SettingsPanelComponent } from '../settings-panel.component';
var LocalizationSettingsComponent = /** @class */ (function (_super) {
    __extends(LocalizationSettingsComponent, _super);
    function LocalizationSettingsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localizations = [];
        return _this;
    }
    LocalizationSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.data.subscribe(function (data) {
            _this.localizations = data.localizations;
        });
    };
    LocalizationSettingsComponent.prototype.getCurrentDate = function () {
        return new Date();
    };
    return LocalizationSettingsComponent;
}(SettingsPanelComponent));
export { LocalizationSettingsComponent };
